import {useQuery} from "@tanstack/react-query";
import {createOutgoingCode} from "../../../../../api/inventory/OutgoingApi";

export const useCreateOutgoingCode = () => {
    const {data} = useQuery({
        queryKey: ["createOutgoingCode"],
        queryFn: async () => await createOutgoingCode(),
        select: (res) => res?.data.result?.outgoingCode ?? "",
    });

    return {data};
};
